import { defineMessages } from '@kyruus/intl';

/**
 * Internationalization messages for the SearchAreaButton component
 */

export const messages = defineMessages({
  searchArea: {
    id: 'searchareabutton.searcharea',
    description: 'Button text to search providers in the current map area',
    defaultMessage: 'Search this area'
  }
});
